import api from "../../index.js";

export const KycManager = (params) => api.get(`/IBMaster/MyTeamKYCById?${params}`);
export const KycRequestAcceptRejectApi = (data) => api.post('Admin/UserRejected-ApprovedKyc', data);
export const GetAllKycByIdApi = (kycId) => api.get(`Admin/GetSingleKYC/${kycId}`);
